import { useEffect, useState } from "react";

// Slow breathing circle: in 4s, out 6s. Calls onDone after `seconds`.
export const BreathCircle = ({ seconds = 60, onDone, color = "#F3C98B", testId = "breath-circle" }) => {
  const [t, setT] = useState(0);
  useEffect(() => {
    const id = setInterval(() => setT((x) => x + 1), 1000);
    return () => clearInterval(id);
  }, []);
  useEffect(() => { if (t >= seconds) onDone?.(); }, [t, seconds, onDone]);
  const inPhase = t % 10 < 4;
  return (
    <div className="flex flex-col items-center text-center" data-testid={testId}>
      <div className="relative w-56 h-56 my-8 flex items-center justify-center">
        <div className="absolute inset-0 rounded-full transition-transform ease-in-out motion-reduce:transition-none" style={{ background: `${color}33`, transform: `scale(${inPhase ? 1 : 0.6})`, transitionDuration: inPhase ? "4000ms" : "6000ms" }} aria-hidden />
        <div className="absolute inset-10 rounded-full transition-transform ease-in-out motion-reduce:transition-none" style={{ background: `${color}55`, transform: `scale(${inPhase ? 1 : 0.6})`, transitionDuration: inPhase ? "4000ms" : "6000ms" }} aria-hidden />
        <div className="relative text-2xl font-semibold" aria-live="polite" data-testid={`${testId}-phase`}>{inPhase ? "Breathe in" : "Breathe out"}</div>
      </div>
      <p className="opacity-70 text-sm">{Math.max(seconds - t, 0)} seconds · in for 4, out for 6</p>
    </div>
  );
};
